/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_FreeInputs */

const en_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free plan`)
};

const es_plan_free = /** @type {(inputs: Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan gratuito`)
};

/**
* | output |
* | --- |
* | "Free plan" |
*
* @param {Plan_FreeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_free = /** @type {((inputs?: Plan_FreeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_FreeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_free(inputs)
	return en_plan_free(inputs)
});